import { Link } from 'react-router-dom'
import logo from '../../images/logo-01.png'
import Shape1 from '../../images/mail.svg'
import News1 from '../../images/phone.svg'
import News2 from '../../images/map.svg'


const ClickHandler = () => {
    window.scrollTo(10, 0);
}



const Footer = (props) => {


    return (
        <footer className="wpo-site-footer">
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <img src={logo} alt="blog" />
                                </div>
                                <p>Faxian IT delivers innovative IT solutions, consulting, and staffing to empower business growth.</p>

                                <div className="social-widget">
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-facebook"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-twitter-alt"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-linkedin"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-instagram"></i></Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Quick Links</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/">Home</Link></li>
                                    <li><Link onClick={ClickHandler} to="/about">About</Link></li>
                                    <li><Link onClick={ClickHandler} to="">Services</Link></li>
                                    <li><Link onClick={ClickHandler} to="">Cloud Technologies</Link></li>
                                    {/* <li><Link onClick={ClickHandler} to="/careers">Careers</Link></li> */}
                                    <li><Link onClick={ClickHandler} to="">Careers</Link></li>
                                    <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget s2">
                                <div className="widget-title">
                                    <h3>Cloud Technologies</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="">Saleforce</Link></li>
                                    <li><Link onClick={ClickHandler} to="">ServiceNow</Link></li>
                                    <li><Link onClick={ClickHandler} to="">AWS</Link></li>
                                    <li><Link onClick={ClickHandler} to="">Azure</Link></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget contact-widget">
                                <div className="widget-title">
                                    <h3>Official Info:</h3>
                                </div>
                                <ul>
                                    <li><img src={Shape1} alt="" /><span><a href="mailto:info@faxianit.com" className='text-white'>info@faxianit.com</a></span>  </li>
                                    <li><img src={News1} alt="" /> <span><a href="tel:+1 (424) 242-2277" className='text-white'>+1 (424) 242-2277</a></span></li>
                                    <li><img src={News2} alt="" /><span>FaxianIT Inc. 4320 Winfield Road, Suite 200 Cornerstone @ Cantera Warrenville Illinois 60555 United States of America</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row g-0">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-6 mx-auto">
                            <p className="copyright"> Copyright &copy; 2025 <Link onClick={ClickHandler} to="/">Faxian IT Inc</Link>. All
                                Rights Reserved.</p>
                        </div>
                        {/* <div className="col col-lg-6 col-12">
                            <ul>
                                <li><Link onClick={ClickHandler} to="/privace">Privace & Policy</Link></li>
                                <li><Link onClick={ClickHandler} to="/terms">Terms</Link></li>
                                <li><Link onClick={ClickHandler} to="/about">About us</Link></li>
                            </ul>

                        </div> */}
                    </div>
                </div>
            </div>
        </footer>

    )
}

export default Footer;

